var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{class:{'bg-black': _vm.enabled, 'bg-light-gray' : !_vm.enabled},attrs:{"enabled":_vm.enabled},on:{"click":function($event){_vm.$emit('click')}}},[_c('span',{staticClass:"white center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }